import { render, staticRenderFns } from "./test_detail.vue?vue&type=template&id=1a90e440&scoped=true"
import script from "./test_detail.vue?vue&type=script&lang=js"
export * from "./test_detail.vue?vue&type=script&lang=js"
import style0 from "./test_detail.vue?vue&type=style&index=0&id=1a90e440&prod&lang=less&scoped=true"
import style1 from "./test_detail.vue?vue&type=style&index=1&id=1a90e440&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a90e440",
  null
  
)

export default component.exports